import type { ChatMessage } from "@lib/agent/types";
import { Paper, Stack, Text, useMantineColorScheme } from "@mantine/core";

export default function UserChatMessage({ message }: { message: ChatMessage }) {
  const { colorScheme } = useMantineColorScheme();

  const isUser = message.role === "user";

  return (
    <Stack flex={1} w="100%" align="flex-end">
      <Paper
        py={5}
        px="sm"
        radius="lg"
        bg={
          isUser
            ? colorScheme === "dark"
              ? "var(--mantine-color-default-border)"
              : "var(--mantine-color-gray-light-hover)"
            : "transparent"
        }
        shadow={isUser ? "xxs" : "none"}
        withBorder={false}
        maw="90%"
        mb="md"
      >
        <Stack gap={4}>
          {message.content && (
            <Text size="sm" fw={500} c="var(--mantine-color-bright)">
              {message.content}
            </Text>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
}
